<div class="toast" [class.toast-err]="isError" *ngIf="visible">
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path *ngIf="!isError" d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline *ngIf="!isError" points="22 4 12 14.01 9 11.01" />
    <circle *ngIf="isError" cx="12" cy="12" r="10" />
    <line *ngIf="isError" x1="12" y1="8" x2="12" y2="12" />
  </svg>
  {{ message }}
</div>
